import React, { useState, useEffect } from "react";
import api from "../api/homeapi";
import { StaffFrame } from "./DashboardShared";
import { downloadTicketsPdf } from "../utils/ticketPdf";

const C = { green:"#006B3C", greenLt:"#E8F5EE", grayBd:"#E0E0E0", text:"#1A1A1A", textSub:"#666" };

const STATUS_STYLE = {
  CONFIRMED: { bg:"#D1FAE5", color:"#065F46", label:"Confirmé" },
  PENDING:   { bg:"#FEF3C7", color:"#92400E", label:"En attente" },
  CANCELLED: { bg:"#FEE2E2", color:"#991B1B", label:"Annulé" },
};

export default function AdminBookings() {
  const [bookings, setBookings] = useState([]);
  const [page,     setPage]     = useState(1);
  const [total,    setTotal]    = useState(0);
  const [loading,  setLoading]  = useState(true);
  const [search,   setSearch]   = useState("");

  const load = async (p = 1) => {
    setLoading(true);
    try {
      const res = await api.get(`/api/admin/bookings?page=${p}`);
      setBookings(res.data.data || res.data);
      setTotal(res.data.total || 0);
      setPage(p);
    } catch {} finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const filtered = search
    ? bookings.filter(b =>
        b.reference?.toLowerCase().includes(search.toLowerCase()) ||
        b.fullName?.toLowerCase().includes(search.toLowerCase()) ||
        b.route?.toLowerCase().includes(search.toLowerCase()))
    : bookings;

  const downloadOne = (b) => downloadTicketsPdf([{
    reference: b.reference,
    passenger: b.fullName,
    seat: b.seatNumber,
    depart: (b.route || "").split(" → ")[0],
    arrivee: (b.route || "").split(" → ")[1],
    date: b.date,
    heure: b.departureTime,
    train: b.trainNumber,
    classe: b.travelClass,
    prix: b.amount,
    tripType: "ALLER",
    qrPayload: b.qrPayload || null,
  }], `billet-setrag-${b.reference || b.id}.pdf`);

  return (
    <StaffFrame>
      <div style={{ padding:28 }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:24 }}>
          <div>
            <h1 style={{ margin:0, fontSize:22, fontWeight:800 }}>Réservations</h1>
            <p style={{ margin:0, color:C.textSub, fontSize:13 }}>Toutes les réservations de billets SETRAG</p>
          </div>
          <input
            placeholder="Rechercher (réf, passager, trajet...)"
            value={search}
            onChange={e => setSearch(e.target.value)}
            style={{ border:`1.5px solid ${C.grayBd}`, borderRadius:10, padding:"9px 14px", fontSize:13, outline:"none", width:260 }}
          />
        </div>

        {loading ? (
          <div style={{ textAlign:"center", padding:60, color:C.textSub }}>Chargement...</div>
        ) : (
          <>
            <div style={{ background:"#fff", borderRadius:14, overflow:"hidden", border:`1px solid ${C.grayBd}` }}>
              <table style={{ width:"100%", borderCollapse:"collapse" }}>
                <thead>
                  <tr style={{ background:C.greenLt }}>
                    {["ID","Référence","Passager","Trajet","Train","Classe","Date","Montant","Statut","Billet"].map(h => (
                      <th key={h} style={{ padding:"11px 12px", textAlign:"left", fontSize:11, fontWeight:700, color:C.textSub, textTransform:"uppercase" }}>{h}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {filtered.map((b,i) => {
                    const st = STATUS_STYLE[b.status] || STATUS_STYLE.PENDING;
                    return (
                      <tr key={b.id} style={{ borderTop:`1px solid ${C.grayBd}`, background:i%2===0?"#fff":"#FAFAFA" }}>
                        <td style={s.td}>{b.id}</td>
                        <td style={s.td}><code style={{ fontSize:11, background:"#f5f5f5", padding:"2px 6px", borderRadius:4 }}>{b.reference}</code></td>
                        <td style={s.td}>{b.fullName}</td>
                        <td style={s.td}>{b.route}</td>
                        <td style={s.td}>{b.trainNumber}</td>
                        <td style={s.td}><span style={{ fontSize:11, fontWeight:600, color:"#6A1B9A" }}>{b.travelClass}</span></td>
                        <td style={s.td}>{b.date}</td>
                        <td style={s.td}><strong>{Number(b.amount).toLocaleString("fr-FR")} FCFA</strong></td>
                        <td style={s.td}>
                          <span style={{ background:st.bg, color:st.color, padding:"3px 9px", borderRadius:20, fontSize:11, fontWeight:600 }}>
                            {st.label}
                          </span>
                        </td>
                        <td style={s.td}>
                          {b.status === "CONFIRMED" && (
                            <button
                              onClick={() => downloadOne(b)}
                              style={{ background:C.green, color:"#fff", border:"none", borderRadius:8, padding:"6px 12px", fontSize:11, fontWeight:700, cursor:"pointer" }}>
                              ⬇ Télécharger
                            </button>
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
              {filtered.length === 0 && (
                <div style={{ textAlign:"center", padding:40, color:C.textSub }}>Aucune réservation trouvée.</div>
              )}
            </div>

            {/* Pagination */}
            <div style={{ display:"flex", justifyContent:"center", gap:8, marginTop:20 }}>
              {[...Array(Math.ceil(total/15))].map((_,i) => (
                <button key={i}
                  onClick={() => load(i+1)}
                  style={{ width:36, height:36, borderRadius:8, border:`1.5px solid ${page===i+1 ? C.green : C.grayBd}`, background:page===i+1 ? C.green : "#fff", color:page===i+1 ? "#fff" : C.text, fontWeight:600, cursor:"pointer", fontSize:13 }}>
                  {i+1}
                </button>
              ))}
            </div>
          </>
        )}
      </div>
    </StaffFrame>
  );
}

const s = { td: { padding:"11px 12px", fontSize:13 } };
